import React, { useEffect } from 'react';
import { PayrollProviderName } from 'api/EmployersApi';
import { getApplicationData } from 'selectors/getApplicationData';
import { useSelector } from 'react-redux';
import { RoutePath } from 'enums/Routes';
import { useNavigate } from 'hooks/useNavigate';
import { FlowComponentType } from 'routes/types';
import { ApplicationStatusName } from 'enums/ApplicationStatusName';
import { updateApplicationStatus } from 'thunks';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import { usePartnerData } from 'enums/PartnerName';
import FormNavigation from 'components/FormNavigation';

import ManualDeduction from './ManualDeduction';

const SetupDeduction = ({ navigationInfo }: FlowComponentType) => {
  const navigate = useNavigate();
  const dispatchWithUnwrap = useDispatchWithUnwrap();

  const { application } = useSelector(getApplicationData);
  const { directDepositInstructions } = usePartnerData();

  const payrollProvider = application?.employment.employer1?.payrollProvider ?? PayrollProviderName.Manual;

  useEffect(() => {
    if (payrollProvider === PayrollProviderName.ManuallySendToHR) {
      (async () => {
        if (application?.status === ApplicationStatusName.SetUpDeduction) {
          await dispatchWithUnwrap(
            updateApplicationStatus({
              applicationId: application!.id,
              applicationStatus: ApplicationStatusName.FinalReview,
            }),
          );
        }
        navigate(RoutePath.OfferStatus);
      })();
    } else if (directDepositInstructions) {
      navigate(RoutePath.SetupViaPayroll);
    }
  }, []);

  return (
    <>
      <FormNavigation {...navigationInfo} />
      <ManualDeduction />
    </>
  );
};

export default SetupDeduction;
